"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                AppBar_CollapseToolTip: "Collapse the action pane",
                AppBar_PinToolTip: "Pin action pane open",
            }
        });
        /**
         * Framework class for AppBarTab control
         */
        var AppBarTab = /** @class */ (function (_super) {
            __extends(AppBarTab, _super);
            function AppBarTab() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            AppBarTab.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this._tabFlyoutElement = element ? element.querySelector(".appBar-flyout") : undefined;
                var _expanded = false;
                this.Expanded = $dyn.computed(function () {
                    // Once the flyout has been opened once, return the value of _expanded. The flyout should remain closed until the server
                    // has opened it for the first time.
                    var hasBeenOpened = $dyn.value(_this.HasBeenOpened);
                    if (hasBeenOpened) {
                        return _expanded;
                    }
                    return hasBeenOpened;
                }, function (newValue) {
                    _expanded = newValue;
                });
                this.FlyoutExpanded = $dyn.computed(function () {
                    return _this.Expanded() && !_this.IsAppBarPinnedOpen();
                }, function (newValue) {
                    _this.Expanded(newValue);
                });
                this.IsAppBarPinnedOpen = $dyn.computed(function () {
                    var appBar = _this._getClosestAppBar();
                    var isPinned = false;
                    if (appBar) {
                        isPinned = $dyn.value(appBar.IsPinnedOpen);
                    }
                    return isPinned;
                });
                this.pinButtonLabel = $dyn.computed(function () {
                    return _this.IsAppBarPinnedOpen() ? $dyn.label("AppBar_CollapseToolTip") : $dyn.label("AppBar_PinToolTip");
                });
                this.flyoutExitAnimation = $dyn.computed(function () {
                    // Don't show a closing animation if the app bar is now pinned open.
                    return _this.IsAppBarPinnedOpen() ? undefined : "appBar-shrinkHeight";
                });
                $dyn.observe(this.HasBeenOpened, function (value) {
                    if (value && _this._tabFlyoutElement) {
                        var role_1 = $dyn.role(element);
                        if (role_1 && element) {
                            $dyn.async(function () {
                                role_1.dataBindChild(_this._tabFlyoutElement, element.dynContext);
                                if (!_this._tabFlyoutElement.dynHasArranged) {
                                    // The flyoutElement needs to have aranged once called on it so the groups are laid out properly.
                                    $dyn.layout.arrange(_this._tabFlyoutElement, true);
                                }
                                else {
                                    $dyn.layout.queueArrange(_this._tabFlyoutElement);
                                }
                            }, undefined, "Data bind newly opened AppBarTab");
                        }
                    }
                });
                $dyn.observe($dyn.options(function () {
                    return { expanded: _this.Expanded };
                }, $dyn.ui.updating), function (newValue) {
                    if (newValue.expanded) {
                        $dyn.layout.queueArrange(_this._tabFlyoutElement);
                    }
                });
                $dyn.setValue(this, "ArrangeMethod", $dyn.layout.ArrangeMethod.none);
                $dyn.observe(this.IsInitiallyOpened, function (value) {
                    // no pin action for small view ports
                    if ($dyn.value(value) && !$dyn.value($dyn.shell.isSmallViewPort)) {
                        $dyn.async(function () {
                            var actionPane = _this._getClosestAppBar();
                            if (actionPane) {
                                actionPane._setPinnedTab(_this, _this._tabFlyoutElement);
                            }
                        }, undefined, "Pin open initial AppBarTab");
                    }
                });
                $dyn.observe(this.Visible, function (newValue) {
                    if (!newValue && _this.Expanded() && _this.IsAppBarPinnedOpen()) {
                        // If the tab is made hidden, while it is the current pinned tab, toggle the pinned state so the ActionPane is unpinned.
                        _this._togglePinnedState();
                    }
                });
                this.OriginalPinnedState = this.IsAppBarPinnedOpen();
            };
            /**
             * @returns header jquery element
             */
            AppBarTab.prototype.getHeader = function () {
                return $(this.element).find(".appBarTab-header");
            };
            /**
             * @returns if control is available for expando personalization feature
             */
            AppBarTab.prototype.isControlAvailableForExpando = function () {
                return true;
            };
            /**
             * @returns expando personalization focus jquery element
             */
            AppBarTab.prototype.getExpandoPersonalizationFocusTarget = function () {
                return this.getHeader();
            };
            /**
             * The keydown event handler.
             * @param evt The keydown event
             */
            AppBarTab.prototype.keyDown = function (evt) {
                if (evt.which === $dyn.ui.KeyCodes.enter) {
                    // Prevent the keyDown from bubbling so the form level enter shortcut is prevented.
                    evt.stopPropagation();
                    $dyn.log.stopPropagation && $dyn.log.stopPropagation("Prevent form level Enter shortcut.");
                }
                if ($dyn.util.isShortcutKeyPressed(evt, { alt: true, keyCode: $dyn.ui.KeyCodes.downArrow })) {
                    this._headerClicked();
                }
            };
            /**
             * This is the handler called when the AppBar tab flyout is open and a click event is detected. Determines if the flyout should stay open.
             * @internal
             * @param options The click options from the flyout binding handler
             * @returns true if the AppBarTab flyout should be closed by the click; otherwise, false
             */
            AppBarTab.prototype.flyoutClickSubscriber = function (options) {
                var $target = $(options.clickTarget);
                // Don't close the flyout if a right-click was performed, or if the click came from an element in our flyout that will open another flyout
                // or if it came from clicking on empty/disabled content in the flyout, or if it came from launching the overflow menu.
                var wantsToClose = !(options.isRightClick ||
                    $target.is(".appBar-overflow") ||
                    (options.flyoutElement &&
                        $target.closest(options.flyoutElement).length &&
                        ($target.closest(".dropDialogButton, .flyoutButton-Button, [disabled]").length ||
                            $target.is(".appBarTab-content, .group, .group_content, .group_title, .appBar-flyout, .appBar-pin"))));
                return wantsToClose;
            };
            AppBarTab.prototype.getTaskGuideParams = function (options) {
                options = _super.prototype.getTaskGuideParams.call(this, options);
                options.my = $dyn.layout.qTipPosition.topCenter;
                options.at = $dyn.layout.qTipPosition.bottomCenter;
                return options;
            };
            /**
             * Toggles the pinned state of the current AppBarTab.
             * @internal
             * @param evt the click event if from a user action
             */
            AppBarTab.prototype._togglePinnedState = function (evt) {
                var _this = this;
                var pinnedState = this.IsAppBarPinnedOpen();
                var appBar = this._getClosestAppBar();
                this.OriginalPinnedState = !pinnedState;
                if (appBar) {
                    var handleFocus_1 = evt ? true : false;
                    if (pinnedState) {
                        // We are pinned and moving to un-pinned so remove the pinned current tab.
                        appBar._removePinnedTab(handleFocus_1);
                    }
                    // Toggle the pinned state.
                    pinnedState = !pinnedState;
                    appBar.IsPinnedOpen(pinnedState);
                    // ignore toggle if small screen
                    if (!$dyn.value($dyn.shell.isSmallViewPort)) {
                        $dyn.callFunction(appBar.PersistPersonalization, appBar, ["IsActionPanePinnedOpen", pinnedState]);
                        // If we are moving from an un-pinnedOpen state to a pinnedOpen state, set this tab as the current pinned tab.
                        if (pinnedState) {
                            // Because the flyout is closed in a timeout, we need to schedule a timeout to set the pinned tab so
                            // the flyout no longer has control over the element when we pin it.
                            $dyn.async(function () {
                                appBar._setPinnedTab(_this, _this._tabFlyoutElement, handleFocus_1);
                            }, undefined, "Pin tab after flyout closes");
                        }
                    }
                }
            };
            /**
             * The click event handler.
             * @internal
             * @param evt The click event
             */
            AppBarTab.prototype._headerClicked = function (evt) {
                if ($dyn.value(this.Enabled)) {
                    var appBarTab = this._getClosestAppBar();
                    this._personalizeFormOpenHandler = this.personalizeFormOpenHandler.bind(this);
                    $(window).on($dyn.forms.Events.personalize, this._personalizeFormOpenHandler);
                    // If personalization mode is on then above event handler will not be executed
                    if ($dyn.ax && $dyn.ax.personalizationUtil && $dyn.ax.personalizationUtil.isPersonalizationModeTurnedOn()) {
                        if (appBarTab) {
                            appBarTab.IsPinnedOpen(true);
                        }
                        this.Expanded(false);
                    }
                    if (!this.Expanded()) {
                        $dyn.applyFunction(this.TabShown, this);
                        // call it explicitly the first time
                        this._updateFlyoutWidth();
                    }
                    if (this.IsAppBarPinnedOpen()) {
                        // Don't do anything if this tab is currently expanded.
                        if (!this.Expanded()) {
                            var handleFocus = evt ? true : false;
                            if (appBarTab) {
                                appBarTab._setPinnedTab(this, this._tabFlyoutElement, handleFocus);
                            }
                        }
                        else {
                            // No matter if the header is pinned or not move the focus to the first control in the tab.
                            $dyn.util.flyout.focusFirstControlInFlyout(this._tabFlyoutElement);
                        }
                    }
                    else {
                        this.Expanded(!this.Expanded());
                    }
                    if ($dyn.ax && $dyn.ax.personalizationUtil) {
                        $dyn.ax.personalizationUtil.forceUpdateFormPersonalizationData();
                    }
                    if (this._asidePaneWidthSubscription === undefined) {
                        this._asidePaneWidthSubscription = $dyn.shell.asidePaneWidth.valueChanged.subscribe(this._updateFlyoutWidth, this);
                    }
                    this._personalizeFormCloseHandler = this.personalizeFormCloseHandler.bind(this);
                    $(window).on("personalizationToolbarClosed", this._personalizeFormCloseHandler);
                }
            };
            AppBarTab.prototype.dispose = function () {
                if ($dyn.value(this.HasBeenOpened)) {
                    // Need to do this becasue the .appBar-flyout element has data-dyn-stop-binding="true" set on it
                    $dyn.unbind(this._tabFlyoutElement);
                }
                if (this._personalizeFormOpenHandler) {
                    $(window).off($dyn.forms.Events.personalize, this._personalizeFormOpenHandler);
                }
                if (this._personalizeFormCloseHandler) {
                    $(window).off("personalizationToolbarClosed", this._personalizeFormCloseHandler);
                }
                $dyn.shell.asidePaneWidth.valueChanged.unsubscribe(this._asidePaneWidthSubscription);
                _super.prototype.dispose.call(this);
            };
            /**
             * Gets the parent AppBar for the current AppBarTab.
             * @returns The parent AppBar for the current AppBarTab
             */
            AppBarTab.prototype._getClosestAppBar = function () {
                if (!this._appBar) {
                    // When the AppBarTab is in overflow, get the context from flyout's overflow button
                    var $appBar = this.isInOverflow ? $($dyn.context(this.element.parentElement).element).closest(".appBar-toolbar") : $(this.element).closest(".appBar-toolbar");
                    if ($appBar && $appBar.length) {
                        this._appBar = $dyn.context($appBar[0]);
                    }
                }
                return this._appBar;
            };
            AppBarTab.prototype.personalizeFormOpenHandler = function () {
                var appBarTab = this._getClosestAppBar();
                if (appBarTab) {
                    appBarTab.IsPinnedOpen(true);
                }
            };
            AppBarTab.prototype.personalizeFormCloseHandler = function () {
                var appBarTab = this._getClosestAppBar();
                if (appBarTab) {
                    appBarTab.IsPinnedOpen(this.OriginalPinnedState);
                }
            };
            /**
             * Runs logic to resize flyout.
             * @description This logic is runs to resize flyout if asidepane changes width
             */
            AppBarTab.prototype._updateFlyoutWidth = function () {
                if ($dyn.value(this.Visible) === true) {
                    if ($dyn.shell.isAsidePaneOpen()) {
                        this._tabFlyoutElement.style.right = $dyn.value($dyn.shell.asidePaneWidth) + "px";
                    }
                }
                else {
                    this._tabFlyoutElement.style.right = "0";
                }
            };
            return AppBarTab;
        }($dyn.ui.Container));
        controls.AppBarTab = AppBarTab;
        AppBarTab.prototype.Label = "";
        AppBarTab.prototype.ImageType = "";
        AppBarTab.prototype.ImageName = "";
        // tslint:disable-next-line:no-string-literal
        AppBarTab.prototype["OriginalPinnedState"] = false;
        AppBarTab.prototype.TabShown = function () {
            $dyn.setValue(this, "HasBeenOpened", true);
        };
        $dyn.ui.addObservablePropertiesToPrototype(AppBarTab.prototype, {
            HasBeenOpened: false,
            IsInitiallyOpened: false,
        });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=AppBarTab.js.map
